import { getUserInfo } from '@/api/admin/user.js'
import { getUserRole } from '@/api/auth.js'

export default {
  state: {
    userInfo: {},
    userRole: []
  },
  getters: {
    // 获取登录用户信息
    getUserInfo(state) {
      return state.userInfo
    },
    // 获取登录用户角色信息
    getUserRole(state) {
      return state.userRole
    },
    // 获取登录用户权限
    getPermissions(state) {
      return state.userInfo.authorities
    }
  },
  mutations: {
    async setUserInfo(state) {
      try {
        const { data } = await getUserInfo()
        state.userInfo = data
      } catch (error) {
        console.error('获取用户信息失败:', error)
        state.userInfo = {}
      }
    },
    async setUserRole(state) {
      try {
        const { data } = await getUserRole()
        state.userRole = data
      } catch (error) {
        console.error('获取用户角色失败:', error)
        state.userRole = []
      }
    }
  },
  actions: {}
}
